import { getProdvmFromDatabridge } from '@xp-utilities/web';
import $document from './document';
import $window from './window';

/**
 * Dispatches a custom event to open the Quick View modal for a product.
 *
 * @param {Event} event - The event object from the triggering UI element (e.g., click event).
 * Used to set the returnFocus property.
 * @param {Object} [product] - The product object containing necessary details for the QuickView.
 * @param {string} [product.brand] - The brand of the product.
 * @param {string} [product.collection] - The collection ID of the product.
 * @param {string} [product.faceout] - The faceout identifier for the product.
 * @param {string} [product.id] - The unique product ID.
 * @param {string} [product.imageId] - The image ID for the product.
 * @param {string} [product.name] - The name of the product.
 * @param {boolean} [flag] - Feature flag related; if true, dispatches the MFE quickview event
 * to the document; otherwise, dispatches the standard quickview event to the window.
 */
const handleAlgonomyProductClick = (event, product = {}, flag = false) => {
  const {
    brand,
    collection,
    faceout,
    id,
    imageId,
    name,
  } = product;
  let qvEventDispatchTarget;
  let qvEventName;
  const prodvm = getProdvmFromDatabridge();
  const pagevm = 'recommendations';

  const eventDetails = {
    productId: id,
    collectionId: collection,
    imageId,
    productName: name,
    productBrand: brand,
    returnFocus: event.target,
    faceout,
  };

  // Set digital data for Algonomy
  if ($window && $window.digitalData) {
    $window.digitalData.set('product.productViewMethod', prodvm);
    $window.digitalData.set('page.pageViewMethod', pagevm);
  }

  if (flag) {
    qvEventName = 'quickview:mfe:openModal';
    qvEventDispatchTarget = $document;
    eventDetails.pageViewMethod = pagevm;
    eventDetails.productViewMethod = prodvm;
  } else {
    qvEventName = 'quickview:openModal';
    qvEventDispatchTarget = $window;
    eventDetails.prodvm = prodvm;
    eventDetails.pagevm = pagevm;
  }

  const quickviewEvent = new CustomEvent(qvEventName, { detail: eventDetails });

  qvEventDispatchTarget.dispatchEvent(quickviewEvent);
};

export default handleAlgonomyProductClick;
